import CalendarSharingError from '../store/schema/CalendarSharingError';
import { getColorSchemeForHexColor } from 'owa-calendar-sharing/lib/utils/colorWrapper';
import getStore from '../store/sharingStore';
import { mutator } from 'satcheljs';
import { showCalendarSharingPermissionsDialog } from '../actions/calendarSharing';

export default mutator(showCalendarSharingPermissionsDialog, msg => {
    getStore().viewState = {
        folderId: msg.folderId,
        calendarTitle: msg.calendarTitle,
        calendarId: msg.calendarId,
        peopleInsideOrg: [],
        peopleOutsideOrg: [],
        delegates: [],
        isPending: false,
        errorStatus: CalendarSharingError.None,
        isInitialLoadError: false,
        isSendInvitePending: false,
        isDeliveryOptionUpdatePending: false,
        isPeoplePickerPermissionPending: false,
        selectedRecipientPermission: null,
        currentDeliveryOption: 1,
        colorScheme: getColorSchemeForHexColor(msg.calendarHexColor),
    };
});
